import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import EntryPage from "./compontents/EntryPage";
import ErrorPage from "./compontents/ErrorPage";
import { request } from "@alipay/rewards-common-tools/index";
import { requestInit } from "./utils/request";
import queryString from "query-string";
import { Toast } from "./utils/toast";
import { expoComponent } from "./utils/tracert";

// 'ERROR' 异常重试 | 'LANDING' 加载中| 'INVENTORY_SHOREAGE' 券无库存| 'SUCCESS' 正常状态，券可领取;

var AcShareVoucherLandingPage = function AcShareVoucherLandingPage(props) {
  var _window, _window$location;
  requestInit();
  var iquicInfo = props.iquicInfo,
    renderData = props.renderData;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    voucherInfo = _useState2[0],
    setVoucherInfo = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    giftSourceInfo = _useState4[0],
    setGiftSourceInfo = _useState4[1];
  var _queryString$parse = queryString.parse((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search),
    giftVoucherParamHexString = _queryString$parse.giftVoucherParamHexString;
  var _useState5 = useState("LANDING"),
    _useState6 = _slicedToArray(_useState5, 2),
    pageState = _useState6[0],
    setpageState = _useState6[1];
  var queryVoucherInfo = function queryVoucherInfo() {
    setpageState("LANDING");
    request("ap.alipayplusrewards.imktuserprod.voucher.giftvoucher.query.nologin", {
      giftVoucherParamHexString: giftVoucherParamHexString
    }).then(function (res) {
      setpageState("SUCCESS");
      setVoucherInfo(res.voucher);
      setGiftSourceInfo(res.giftSourceInfo);
    }).catch(function (err) {
      var state = "";
      if (err.ungiftableReasonCode === "HAS_BEEN_COLLECTED_BY_OTHERS") {
        state = "INVENTORY_SHOREAGE";
        setpageState("INVENTORY_SHOREAGE");
      } else {
        state = "ERROR";
        setpageState("ERROR");
      }
      expoComponent(iquicInfo, _objectSpread(_objectSpread(_objectSpread({}, err.voucherInfo), err.giftSourceInfo), {}, {
        state: state
      }));
    });
  };
  useEffect(function () {
    // C位曝光

    queryVoucherInfo();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, pageState === "SUCCESS" && /*#__PURE__*/React.createElement(EntryPage, _extends({}, props, {
    voucherInfo: voucherInfo,
    giftSourceInfo: giftSourceInfo
  })) || /*#__PURE__*/React.createElement(ErrorPage, _extends({}, props, {
    state: pageState,
    queryVoucherInfo: queryVoucherInfo
  })), /*#__PURE__*/React.createElement(Toast, null));
};
export default AcShareVoucherLandingPage;
